import { useNavigate, useSearch } from "@tanstack/react-router";
import { useEffect } from "react";
import type { FilterSpec } from "@/components/data";
import { applyFilters, parseFilters, type FilterValues } from "@/lib/filters";
import type { Entity } from "./api";
import { todayFor } from "./format";

export const ENTITY_SPEC: FilterSpec = { name: "entity", label: "Entity", kind: "choice", anyLabel: "All entities", options: [
  { value: "LTD", label: "Ketosource Limited (GBP)" }, { value: "OU", label: "Ketosource OÜ (EUR)" },
] };
export type Scope = { entity: Entity; asAt: string | null; isHistorical: boolean; today: string; values: FilterValues; onChange: (next: FilterValues) => void };
export function isEntity(value: unknown): value is Entity { return value === "LTD" || value === "OU" || value === "all"; }
const DATE = /^\d{4}-\d{2}-\d{2}$/;
export function scopeFrom(values: FilterValues, now: Date = new Date()): Pick<Scope, "entity" | "asAt" | "isHistorical" | "today"> {
  const entity: Entity = isEntity(values.entity) ? values.entity : "all"; const today = todayFor(entity, now);
  const raw = typeof values.asat === "string" && DATE.test(values.asat) ? values.asat : null; const asAt = raw && raw < today ? raw : null;
  return { entity, asAt, isHistorical: asAt !== null, today };
}
export function writesAllowed(scope: Pick<Scope, "isHistorical">): boolean { return !scope.isHistorical; }
export function useScope(): Scope {
  const search = useSearch({ strict: false }) as Record<string, unknown>; const navigate = useNavigate(); const values = parseFilters(search); const derived = scopeFrom(values);
  const rawAsAt = typeof values.asat === "string" ? values.asat : null;
  useEffect(() => {
    if (rawAsAt && derived.asAt === null) void navigate({ search: applyFilters(search, { asat: null }) as never, replace: true });
  }, [derived.asAt, navigate, rawAsAt, search]);
  return { ...derived, values, onChange: (next) => { void navigate({ search: applyFilters(search, next) as never, replace: true }); } };
}
